/**
 * Shared component for React
 * Using our custom React components
 */

import React from 'react';

/**
 * Card component using Tabler CSS classes for proper dark mode support
 */
const Card = ({ title, children, className = '', ...props }) => {
  return (
    <div className={`card ${className}`} {...props}>
      {title && (
        <div className="card-header">
          <h3 className="card-title">{title}</h3>
        </div>
      )}
      {children}
    </div>
  );
};

export default Card;
